var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetmanagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 19.803 19.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.837 -257.102)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M219.837,262.927h9.4v4.081l-1.479-.769a4.656,4.656,0,0,0-.532,1.419h-6.624v.592h6.565a3.875,3.875,0,0,0,2.07,3.43v4.908h-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M226.668,261.478V257.1h10.763v13.779a6.192,6.192,0,0,0-.887.06l-1.774-1.775a3.81,3.81,0,0,0-.946-3.548,3.715,3.715,0,0,0-3.135-1.183v-2.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M230.453,268.93l1.183-1.183-.828-1.833a2.373,2.373,0,0,1,2.306,3.43l3.194,3.193a2.343,2.343,0,0,1,2.425.237,2.317,2.317,0,0,1,.887,2.07l-1.775-.828-1.182,1.183.828,1.774a2.278,2.278,0,0,1-2.248-1.065,2.521,2.521,0,0,1-.118-2.247l-3.194-3.253a2.384,2.384,0,0,1-2.306-.177,2.541,2.541,0,0,1-.946-2.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M231.789,261.895a.694.694,0,1,0,.694.693.694.694,0,0,0-.694-.693Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M233.176,262.357a.231.231,0,0,0,0,.462h3.7a.231.231,0,0,0,0-.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M233.331,260.266l-.386.188a1.176,1.176,0,0,0,1.074.617v.361h.3v-.366c.568-.056.934-.375.934-.813,0-.5-.4-.669-.934-.835v-.945a.619.619,0,0,1,.491.357l.376-.18a1.057,1.057,0,0,0-.867-.552v-.365h-.3v.361c-.453.038-.91.3-.91.787s.412.667.91.821v.995a.753.753,0,0,1-.688-.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M234.323,260.687h0V259.8c.308.111.486.222.486.463s-.181.391-.486.431Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M234.02,259.319h0c-.288-.1-.467-.213-.467-.439s.179-.378.467-.412v.851Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M222.144,273.655a.694.694,0,1,0,.693.694.694.694,0,0,0-.693-.694h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M223.531,274.118a.231.231,0,1,0,0,.462h3.7a.231.231,0,1,0,0-.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M223.685,272.026l-.385.189a1.173,1.173,0,0,0,1.074.616v.362h.3v-.366c.568-.056.935-.375.935-.813,0-.5-.4-.669-.935-.835v-.946a.62.62,0,0,1,.492.358l.376-.181a1.059,1.059,0,0,0-.868-.551v-.365h-.3v.361c-.453.038-.91.295-.91.786s.412.668.91.822v.994a.749.749,0,0,1-.688-.431Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M224.678,272.448h0v-.891c.308.11.486.222.486.462s-.182.392-.486.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M224.375,271.08h0c-.289-.1-.467-.213-.467-.44s.179-.377.467-.411v.851Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetmanagement);
export default __webpack_public_path__ + "static/media/Assetmanagement.621f5f20c708bb0a89ac9c41b33921cd.svg";
export { ForwardRef as ReactComponent };